import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M15.493 29.095c-7.465 0-13.538-6.050-13.538-13.487s6.073-13.487 13.538-13.487c7.465 0 13.538 6.050 13.538 13.487s-6.073 13.487-13.538 13.487z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4AC2F9",
			d: "M15.493 1.035c-8.079 0-14.629 6.524-14.629 14.573s6.549 14.573 14.629 14.573c8.079 0 14.629-6.524 14.629-14.573s-6.549-14.573-14.629-14.573zM15.493 3.208c6.864 0 12.448 5.563 12.448 12.4s-5.584 12.4-12.448 12.4c-6.864 0-12.448-5.563-12.448-12.4s5.584-12.4 12.448-12.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M20.869 19.762l-2.794-1.532v2.877z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#80d4fa",
			d: "M12.751 9.164l1.102 1.864 2.358 4.009 5.87-2.715-3.46-5.865z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4AC2F9",
			d: "M11.043 10.007l-2.666 2.537v7.652l1.564 0.851v-5.439l2.29 1.251v5.431l2.264 1.226v-7.644l-2.375-4.043-0.009-0.009z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e47a2",
			d: "M13.854 11.029l-1.735 0.8 2.375 4.043v1.626l0.889-0.4 0.829 0.46v-1.192l5.87-2.715-1.324-0.715-4.546 2.102z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0288d1",
			d: "M17.468 20.86v-3.796l3.597-1.728v3.796l-1.051 0.502-2.546 1.226zM16.212 16.366v7.116l5.87-2.715v-7.116l-5.87 2.715z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e47a2",
			d: "M17.468 18.238l2.546 1.396 1.051-0.502v-3.796l-3.597 1.728z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0e47a2",
			d: "M9.94 19.498l2.29-1.005v-1.634l-2.29-1.251z"
		})
	]
});
export default SvgLogoCircle;
